/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-05-28 15:48:46
 */

import { request } from "./api-require";

const API_URL = "/oms-order-service/v1";
import { objAny } from "../common/common-interface";

//获取提现单统计
export const getDrawcashMch = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/drawcash/mch/sum", data, config);
};
//获取提现单页面
export const getDrawcashPage = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/drawcash/page", data, config);
};
//
//获取详情--提现规则
export const getDrawcashDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(API_URL + "/order/drawcash/detail", data, config);
};
// 新增提现单
export const getDrawcashSave = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/drawcash/save", data, config);
};
// 提现单预览明细
export const getPreviewOrderDetail = (data = {}, config: objAny = {}) => {
  config.method = "get";
  return request(
    API_URL + "/order/drawcash/preview/order_detail",
    data,
    config
  );
};
// 撤回
export const getDrawcashCancel = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/drawcash/cancel", data, config);
};
//分成日结单
export const getSettlementOrderPage = (data = {}, config: objAny = {}) => {
  return request(
    API_URL + "/order/settlement/page/settlement_order",
    data,
    config
  );
};
// 日结单审核或作废
export const getSettlementOrderAudit = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/order/settlement/audit/mch", data, config);
};
//订单分成明细
export const getSettlementOrderDetail = (data = {}, config: objAny = {}) => {
  return request(
    API_URL + "/order/settlement/page/settlement_order_detail",
    data,
    config
  );
};
//账户-现金退款
export const getTransactionCashRefund = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/transaction/cash/refund", data, config);
};

//账户-现金充值
export const TransactionCash = (data = {}, config: objAny = {}) => {
  return request(API_URL + "/recharge/page", data, config);
};
